import React from "react";

const ResponseTestLinkSegment: React.FC = () => {
  return (
    <div className="response-segment">
      <div className="segment-name">
        Response Test Link
      </div>
      <div className="row">
        <div className="col" style={{ "marginBottom": "20px" }}>
          <a href={window.location.href}>{window.location.href}</a>
        </div>
      </div>
    </div>
  );
};

export default ResponseTestLinkSegment;
